import { IHeadCell } from 'components/table/EnhancedTableHead';
import { AssetConnectionsTableItem } from 'models/assetDataFlows/dto';

const tableConfig: IHeadCell<AssetConnectionsTableItem>[] = [
	{
		id: 'is_encrypted',
		numeric: false,
		label: '',
		sortable: false,
		filter: false,
	},
	{
		id: 'name',
		numeric: false,
		label: 'Interacts with',
		sortable: true,
		filter: true,
	},
	{
		id: 'sensitivity',
		numeric: false,
		label: 'Sensitivity',
		sortable: true,
	},
	{
		id: 'data_types',
		numeric: false,
		label: 'Stored data types',
		sortable: false,
	},
	{
		id: 'last_seen',
		numeric: false,
		label: 'Last checked',
		sortable: true,
		reversedSort: true,
	},
];

export default tableConfig;
